import {z} from 'zod'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {useEffect, useState} from 'react'
import {QUERY_KEYS} from '@/queryClient.ts'
import {PaginationResponse} from '@/types.ts'
import {Access} from '@/features/accesses/types'
import {httpGetAccessesTable, HttpGetAccessesTableOptions} from '@/features/accesses/http/accesses.http'

const ResponseShape = z.object({data: z.array(Access), meta: PaginationResponse})
type ResponseShape = z.infer<typeof ResponseShape>

export const useAccessesTable = (
    params: HttpGetAccessesTableOptions['params'],
    payload?: HttpGetAccessesTableOptions['payload'],
    options?: Omit<UseQueryOptions<ResponseShape>, 'queryKey' | 'queryFn'>
) => {
    const [persistedPagination, setPersistedPagination] = useState<PaginationResponse>({
        total: 0,
        lastPage: 1,
        perPage: 50,
        currentPage: 1
    })

    const query = useQuery({
        queryKey: [QUERY_KEYS.ACCESSES, params, payload],
        queryFn: () => httpGetAccessesTable({params, payload}),
        ...options
    })

    useEffect(() => {
        if (query.isSuccess) {
            setPersistedPagination(query.data.meta)
        }
    }, [
        query.isSuccess,
        query.data?.meta.currentPage,
        query.data?.meta.lastPage,
        query.data?.meta.perPage,
        query.data?.meta.total
    ])

    return {...query, persistedPagination}
}
